mutation UpdateBunnySettings($input: UpdateBunnySettingsInput!) {
  updateBunnySettings(input: $input) {
    id
    bunnySettings {
      libraryId
      cdnHostname
      apiKeyMask
      connectedAt
    }
  }
}
